import { Component } from "react";
import { Link } from "react-router-dom";

export class RouteErrorBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error) {
    // Never send message content, property IDs, email or chat transcripts to analytics.
    console.error("Route render failed", error?.name || "Error");
  }
  render() {
    if (!this.state.failed) return this.props.children;
    return <main className="min-h-[65vh] bg-[#F4F7FC] text-[#112844] px-6 py-20" data-testid="route-error-boundary">
      <div className="max-w-xl mx-auto"><h1 className="text-3xl font-semibold mb-4" data-testid="route-error-title">This screen couldn’t finish loading</h1>
        <p role="alert" className="mb-6" data-testid="route-error-message">You can try again or get help from our team. If you just submitted a booking or payment, contact us before submitting it again.</p>
        <div className="flex flex-wrap gap-3"><button type="button" onClick={() => this.setState({ failed: false })} className="bg-blue-700 text-white px-5 min-h-12 rounded-lg" data-testid="route-error-retry">Try again</button>
          <button type="button" onClick={() => window.location.reload()} className="border border-slate-400 px-5 min-h-12 rounded-lg" data-testid="route-error-reload">Reload screen</button>
          <Link to="/help" className="px-3 min-h-12 inline-flex items-center underline" data-testid="route-error-guides">Help guides</Link>
          <a href="tel:2398344377" className="px-3 min-h-12 inline-flex items-center underline" data-testid="route-error-call">Call (239) 834-4377</a></div>
      </div>
    </main>;
  }
}